import { render, staticRenderFns } from "./ContactViewMain.vue?vue&type=template&id=04cb2188"
import script from "./ContactViewMain.vue?vue&type=script&lang=js"
export * from "./ContactViewMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports